/**
 * Calculate totals from detail rows
 */
export const calculateTotals = (detailRows: any[] = []) => {
  const totalPSNo = detailRows.reduce((sum: number, row: { ps_no_nt: number | string }) => {
    const value = typeof row.ps_no_nt === 'string' ? parseFloat(row.ps_no_nt) : row.ps_no_nt;
    return sum + (value || 0);
  }, 0);

  const totalPSCo = detailRows.reduce((sum: number, row: { ps_co_nt: number | string }) => {
    const value = typeof row.ps_co_nt === 'string' ? parseFloat(row.ps_co_nt) : row.ps_co_nt;
    return sum + (value || 0);
  }, 0);

  return {
    totalPSNo,
    totalPSCo
  };
};

export const handleUpdateRowFields = (row: any, field: string, newValue: any) => {
  if (field === 'ps_no_nt') {
    return {
      ps_no_nt: newValue,
      ps_co_nt: 0
    };
  }
  if (field === 'ps_co_nt') {
    return {
      ps_no_nt: 0,
      ps_co_nt: newValue
    };
  }

  return {};
};
